



















import {
  Component,
  Vue,
} from 'vue-property-decorator';
import {
  Getter,
} from 'vuex-class';
import { ApiV2Service } from '@/services/api.base.service';

@Component({
  components: {
  },
})
export default class FlowEditor extends Vue {

  @Getter private activeOrganisation: any;
  private launched = false;

  private async launchNR() {
    await ApiV2Service.post(`admin/launchFlowEditor?orgId=${this.activeOrganisation[0].id}`, {});

    this.launched = true;
  }

  private async retry() {
    this.$router.push(`/organisation/${this.activeOrganisation[0].id}/publish/flow-editor`);
  }
}
